$(document).ready(function () {
    const $status = $('.js-invoice-status')
    if ($status.length > 0) {
        const uuid = $status.data('uuid')

        const loadingText = $status.data('loadingText')

        printProgress('<p>' + loadingText + '</p>');

        let timerId = setInterval(function () {
            $.ajax({
                method: 'GET',
                url: '/invoices/info',
                data: {
                    "uuid": uuid,
                },
                success: function (response) {
                    if (response.data.status === "1") {
                        printProgress('<p>' + loadingText + '</p>');
                    } else {
                        clearInterval(timerId)
                        window.location.reload()
                    }
                }
            })
        }, 5000)
    }

    function printProgress(html) {
        $status.html(html)
    }
})
